// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".system-availability[data-v-319a7666] {\n  max-width: 170px;\n  max-height: 100px;\n}\n@media screen and (max-width: 1264px) {\n.system-availability[data-v-319a7666] {\n    max-width: 120px;\n    max-height: 100px;\n}\n}", ""]);
// Exports
module.exports = exports;
